/**
 * Shell badge counts for Invite, Messages, and the notification bell.
 *
 * Values come from POST /invite/list, POST /chat/list-mine, and
 * POST /inbox/get-unread-count, all polled at SHELL_BADGE_POLL_MS.
 */
import { useChatListMine } from "@sportsmet/messaging-sdk/private";
import { useInboxGetUnreadCount } from "@sportsmet/notification-sdk/private";
import { useInviteList } from "@sportsmet/pool-sdk/private";

export const SHELL_BADGE_POLL_MS = 30_000;

export type typeShellBadges = {
  /** Pending, unactioned pool invitations. 0 renders no badge, never a "0". */
  inviteCount: number;
  /** Unread messages across every chat the fan can open. 0 renders no badge, never a "0". */
  messageUnreadCount: number;
  /** Unread in-app notification inbox count, for the bell ISSUE-326 adds. */
  notificationCount: number;
};

export const NO_SHELL_BADGES: typeShellBadges = {
  inviteCount: 0,
  messageUnreadCount: 0,
  notificationCount: 0,
};

export function useShellBadges(): typeShellBadges {
  const inviteList = useInviteList(
    {},
    { refetchInterval: SHELL_BADGE_POLL_MS },
  );
  const chatList = useChatListMine(
    {},
    { refetchInterval: SHELL_BADGE_POLL_MS },
  );
  const unread = useInboxGetUnreadCount(
    {},
    { refetchInterval: SHELL_BADGE_POLL_MS },
  );
  return {
    inviteCount: inviteList.data?.data?.pendingCount ?? 0,
    messageUnreadCount: chatList.data?.data?.totalUnreadCount ?? 0,
    notificationCount: unread.data?.data?.unreadCount ?? 0,
  };
}
